import { createIcon } from './icon-utils';

export const OptionsMenuIcon = createIcon({
  path: 'M7.5 14c-.828 0-1.5-.672-1.5-1.5S6.672 11 7.5 11s1.5.672 1.5 1.5S8.328 14 7.5 14zm10 0c-.828 0-1.5-.672-1.5-1.5s.672-1.5 1.5-1.5 1.5.672 1.5 1.5-.672 1.5-1.5 1.5zm-5 0c-.828 0-1.5-.672-1.5-1.5s.672-1.5 1.5-1.5 1.5.672 1.5 1.5-.672 1.5-1.5 1.5z',
});
